import {
  createGlobalStyle,
  css,
  DefaultTheme,
  GlobalStyleComponent,
} from 'styled-components'
import theme from './theme'

type GlobalStylesProps = {
  removeBg?: boolean
}

const GlobalStyles: GlobalStyleComponent<
  //@ts-ignore
  GlobalStylesProps,
  DefaultTheme
> = createGlobalStyle`
  ${css`
    * {
      font-family: 'Inter', 'Helvetica', 'Arial', sans-serif;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      outline: none;

      &::before,
      &::after {
        box-sizing: inherit;
      }
    }
    html {
      font-size: 62.5%;
    }
    .MuiDataGrid-panel {
      .MuiDataGrid-paper {
        .MuiInputLabel-formControl,
        .MuiInputBase-input {
          font-size: ${theme.typograph.fontsize.h3};
        }
        .MuiDataGrid-panelContent {
          .MuiTypography-root {
            font-size: ${theme.typograph.fontsize.h3};
          }
        }
        .MuiDataGrid-panelFooter {
          .MuiButtonBase-root {
            font-size: ${theme.typograph.fontsize.h3};
          }
        }
      }
    }
    .MuiDataGrid-menu {
      .MuiDataGrid-menuList {
        .MuiMenuItem-root {
          font-size: ${theme.typograph.fontsize.h3};
        }
      }
    }
    .MuiModal-root {
      .MuiMenu-list {
        .MuiTablePagination-menuItem {
          font-size: ${theme.typograph.fontsize.h3};
        }
      }
    }

    .MuiAutocomplete-popper * {
      font-size: ${theme.typograph.fontsize.h3};
    }

    .MuiPaper-elevation {
      .MuiDateCalendar-root {
        .MuiPickersCalendarHeader-root {
          .MuiPickersCalendarHeader-label {
            font-size: ${theme.typograph.fontsize.h3};
          }
        }
        .MuiSvgIcon-root {
          width: 1.5em;
          height: 1.5em;
        }
        .MuiPickersYear-root {
          .MuiPickersYear-yearButton {
            font-size: ${theme.typograph.fontsize.h3};
          }
        }
        .MuiDayCalendar-header {
          .MuiTypography-caption {
            font-size: ${theme.typograph.fontsize.h3};
          }
        }
        .MuiDateCalendar-viewTransitionContainer {
          .MuiPickersDay-root {
            font-size: ${theme.typograph.fontsize.h3};
          }
        }
      }
    }
  `}
  .MuiTooltip-popper {
    .MuiTooltip-tooltip {
        font-size: ${theme.typograph.fontsize.h3};
    }
  }`

export default GlobalStyles
